import { hbs } from 'ember-cli-htmlbars';
export default hbs("<footer class=\"bv-popover__footer\" ...attributes>\n  {{yield @popover}}\n</footer>")